import { useEffect, useState } from "react";
import moment from "moment-timezone";
import { useGridDates } from "./useGridDates";
import { useDateFilters } from "../../../../../components/shared/filters/DateFilters/context/useDateFilters";

export interface CurrentTimeOffset {
    cellWidth: number;
}

export const useCurrentTimeOffset = ({ cellWidth }: CurrentTimeOffset): number | null => {
    const [currentTimeOffset, setCurrentTimeOffset] = useState<number | null>(null);
    const { mode } = useDateFilters();
    const { gridStartTime, gridEndTime } = useGridDates();

    useEffect(() => {
        const calculateAndSetOffset = () => {
            if (!gridStartTime || mode !== "day" || cellWidth <= 0) {
                setCurrentTimeOffset(null);
                return;
            }
            const now = moment();
            if (now.isBetween(gridStartTime, gridEndTime)) {
                const offsetMinutes = now.diff(gridStartTime, "minutes");
                const leftOffset = (offsetMinutes / 60) * cellWidth;
                setCurrentTimeOffset(leftOffset);
            } else {
                setCurrentTimeOffset(null);
            }
        };
        calculateAndSetOffset();
        const intervalId = setInterval(calculateAndSetOffset, 60000);
        return () => clearInterval(intervalId);
    }, [gridStartTime, mode, cellWidth, gridEndTime]);
    return currentTimeOffset;
};
